import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times" />
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search" />
          </button>
        </form>
      </div>
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times" />
          </button>
          <div className="mobile-logo">
            <Link to="/">
              <img src="/assets/img/logo.webp" alt="#" />
            </Link>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="/properties/residential">Properties</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/properties/residential">Residential</Link>
                  </li>
                  <li>
                    <Link to="/properties/commercial">Commercial</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/international">International</Link>
              </li>
              <li>
                <Link to="/developers">Developers</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/services">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/buying">Buying</Link>
                  </li>
                  <li>
                    <Link to="/selling">Selling</Link>
                  </li>
                  <li>
                    <Link to="/leasing">Leasing</Link>
                  </li>
                  <li>
                    <Link to="/portfolio-management">Portfolio Management</Link>
                  </li>
                  <li>
                    <Link to="/property-management">Property Management &amp; Maintenance</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/blog">Insights</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="header-links">
            <ul>
              <li>
                <div className="th-social ">
                  <button type="button" className="social-icon-button" aria-label="Facebook">
                    <i className="fab fa-facebook-f" />
                  </button>
                  <button type="button" className="social-icon-button" aria-label="Twitter">
                    <i className="fab fa-twitter" />
                  </button>
                  <button type="button" className="social-icon-button" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in" />
                  </button>
                  <button type="button" className="social-icon-button" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp" />
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <header className="th-header header-default header-layout1">
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assets/img/logo.webp" width="220px" alt="#" />
                    </Link>
                  </div>
                </div>
                <div className="col-auto">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <ul>
                      <li className="menu-item-has-children">
                        <Link to="/properties/residential">Properties</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to="/properties/residential">Residential</Link>
                          </li>
                          <li>
                            <Link to="/properties/commercial">Commercial</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/international">International</Link>
                      </li>
                      <li>
                        <Link to="/developers">Developers</Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link to="/services">Services</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to="/buying">Buying</Link>
                          </li>
                          <li>
                            <Link to="/selling">Selling</Link>
                          </li>
                          <li>
                            <Link to="/leasing">Leasing</Link>
                          </li>
                          <li>
                            <Link to="/portfolio-management">Portfolio Management</Link>
                          </li>
                          <li>
                            <Link to="/property-management">Property Management &amp; Maintenance</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li>
                        <Link to="/blog">Insights</Link>
                      </li>
                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                  <button type="button" className="th-menu-toggle d-block d-lg-none">
                    <i className="far fa-bars" />
                  </button>
                </div>
                <div className="col-auto d-none d-xl-block">
                  <div className="header-button">
                    <Link to="/list-your-property" className="th-btn pill text-white">
                      <i className="fa-regular fa-house-chimney me-2" />
                      List Your Property
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
